export default {
  init() {

    $('.js-training-session-register-jumplink').on('click', function() {
      singleTrainingSessionJumpLink();
    });

  },
};

function singleTrainingSessionJumpLink() {
    document.querySelector('.js-training-session-register').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start',
    });
}


// WEBPACK FOOTER //
// ./scripts/routes/single-training_session.js